import { render } from "./RequestTable.vue?vue&type=template&id=2d4e4055"
import script from "./RequestTable.vue?vue&type=script&lang=js"
export * from "./RequestTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__